var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
      _c("span", [_vm._v("Vendor Status")]),
    ]),
    _c("div", { staticClass: "ca-form" }, [
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-auto", attrs: { label: "Notifications" } },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.setNotifyMode },
                  model: {
                    value: _vm.modeEmail,
                    callback: function ($$v) {
                      _vm.modeEmail = $$v
                    },
                    expression: "modeEmail",
                  },
                },
                [_vm._v("Email")]
              ),
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.setNotifyMode },
                  model: {
                    value: _vm.modeText,
                    callback: function ($$v) {
                      _vm.modeText = $$v
                    },
                    expression: "modeText",
                  },
                },
                [_vm._v("SMS Text")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-auto", attrs: { label: "Notify On" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.value.notifyOnSubmit,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "notifyOnSubmit", $$v)
                    },
                    expression: "value.notifyOnSubmit",
                  },
                },
                [_vm._v("Submit")]
              ),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.value.notifyOnLostBid,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "notifyOnLostBid", $$v)
                    },
                    expression: "value.notifyOnLostBid",
                  },
                },
                [_vm._v("Lost Bid")]
              ),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.value.notifyOnReAssign,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "notifyOnReAssign", $$v)
                    },
                    expression: "value.notifyOnReAssign",
                  },
                },
                [_vm._v("Re-Assignment")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Vendor Status" } },
            [
              _c("VendorStatusOption", {
                model: {
                  value: _vm.value.vendorStatusId,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "vendorStatusId", $$v)
                  },
                  expression: "value.vendorStatusId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Vendor Type" } },
            [
              _c("VendorTypeOption", {
                model: {
                  value: _vm.value.vendorTypeId,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "vendorTypeId", $$v)
                  },
                  expression: "value.vendorTypeId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Vendor Role" } },
            [
              _c("VendorRoleOption", {
                model: {
                  value: _vm.value.vendorRoleId,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "vendorRoleId", $$v)
                  },
                  expression: "value.vendorRoleId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Vendor Rank" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.vendorRank,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "vendorRank", $$v)
                  },
                  expression: "value.vendorRank",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Daily Order Limit" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.dailyOrderLimit,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "dailyOrderLimit", $$v)
                  },
                  expression: "value.dailyOrderLimit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-25", attrs: { label: "Performance" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.performance,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "performance", $$v)
                  },
                  expression: "value.performance",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-25", attrs: { label: "Assigned" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.ordersAssigned,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "ordersAssigned", $$v)
                  },
                  expression: "value.ordersAssigned",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-25", attrs: { label: "In Process" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.ordersInProcess,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "ordersInProcess", $$v)
                  },
                  expression: "value.ordersInProcess",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-25", attrs: { label: "Late" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.ordersLate,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "ordersLate", $$v)
                  },
                  expression: "value.ordersLate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-25", attrs: { label: "On Hold" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.ordersOnHold,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "ordersOnHold", $$v)
                  },
                  expression: "value.ordersOnHold",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-25", attrs: { label: "Completed" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.ordersCompleted,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "ordersCompleted", $$v)
                  },
                  expression: "value.ordersCompleted",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { staticClass: "w-25", attrs: { label: "Declined" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.value.ordersDeclined,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "ordersDeclined", $$v)
                  },
                  expression: "value.ordersDeclined",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Halt Assignment" } },
            [
              _c("span", [_vm._v("From ")]),
              _c("el-date-picker", {
                staticStyle: { width: "140px" },
                attrs: {
                  type: "date",
                  format: "yyyy/MM/dd",
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.value.haltAssignStart,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "haltAssignStart", $$v)
                  },
                  expression: "value.haltAssignStart",
                },
              }),
              _c("span", [_vm._v(" Thru ")]),
              _c("el-date-picker", {
                staticStyle: { width: "140px" },
                attrs: {
                  "aria-label": "Thru",
                  type: "date",
                  format: "yyyy/MM/dd",
                  "value-format": "yyyy-MM-dd",
                },
                model: {
                  value: _vm.value.haltAssignStop,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "haltAssignStop", $$v)
                  },
                  expression: "value.haltAssignStop",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }